import React from 'react';
import {Text, View} from '@react-pdf/renderer';
import {buildStyles} from './quotePdfStyles';
import type {QuoteFont} from '../resolver/types';

type SectionLabelProps = {
	font: QuoteFont;
	brandColor: string;
	children: string;
};

/** Uppercase section label with a short brand-colored bar — heads every authored section. */
const SectionLabel = ({font, brandColor, children}: SectionLabelProps): JSX.Element => {
	const styles = buildStyles(font);
	return (
		<View style={styles.sectionLabelRow}>
			<View style={[styles.sectionLabelBar, {backgroundColor: brandColor}]} />
			<Text style={[styles.sectionLabelText, {color: brandColor}]}>{children}</Text>
		</View>
	);
};

export default SectionLabel;
